import React from 'react';
import { ContentsPropTypes } from './ContentPropTypes';

// TODO: あとで消す
export default function UnknownComponent({ content }: ContentsPropTypes) {
  return <div>デバッグ情報：{JSON.stringify(content)}</div>;
}
